import { Layout } from "../layout/layout";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, ArrowLeft, Home, Search } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { cardVariants, containerVariants } from "@/components/animations/animations-motion";


export default function NotFound() {
  const [, navigate] = useLocation();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Layout title="not-found">
      <motion.div 
        className="min-h-screen w-full flex items-center justify-center bg-[var(--color-background)] px-4 relative overflow-hidden"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Elementos decorativos de fondo */}
        <div 
          className="absolute top-1/4 left-1/4 w-20 h-20 bg-[var(--color-accent)] rounded-full opacity-40 animate-pulse"
        />
        <div 
          className="absolute bottom-1/3 right-1/4 w-16 h-16 bg-[var(--color-success)] rounded-full opacity-30 animate-pulse"
        />
        <div 
          className="absolute top-1/3 right-1/3 w-12 h-12 bg-[var(--color-primary)] rounded-full opacity-10 animate-pulse"
        />

        <motion.div
          className="w-full max-w-2xl mx-auto"
          variants={cardVariants}
        >
          <Card className="w-full border-0 shadow-2xl rounded-2xl overflow-hidden bg-white">
            <CardContent className="p-8 md:p-12">
              <div className="text-center">
                {/* Icono animado */}
                <div
                  className="flex justify-center mb-6"
                >
                  <div className="relative">
                    <div
                      className="w-24 h-24 bg-gradient-to-br from-[var(--color-accent)] to-[var(--color-secondary)] rounded-full flex items-center justify-center shadow-lg"
                    >
                      <AlertCircle className="h-12 w-12 text-white" />
                    </div>
                    <div
                      className="absolute -top-2 -right-2 w-8 h-8 bg-[var(--color-success)] rounded-full flex items-center justify-center"
                    >
                      <Search className="h-4 w-4 text-white" />
                    </div>
                  </div>
                </div>

                {/* Texto principal */}
                <div>
                  <h1 className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] bg-clip-text text-transparent mb-4">
                    404
                  </h1>
                  <h2 className="text-3xl md:text-3xl font-bold text-gray-800 mb-4">
                    Página No Encontrada
                  </h2>
                  <p className="text-xl text-gray-600 mb-2 max-w-md mx-auto leading-relaxed">
                    ¡Ups! La página que estás buscando no existe.
                  </p>
                  <p className="text-md text-gray-500 mb-8">
                    Revisa la URL o navega usando las opciones de abajo.
                  </p>
                </div>

                {/* Botones de acción */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <div>
                    <Button
                      onClick={handleGoBack}
                      className="bg-gradient-to-r from-[var(--color-secondary)] to-[var(--color-primary)] hover:-translate-y-1 hover:scale-110 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-200 flex items-center gap-2"
                    >
                      <ArrowLeft className="h-4 w-4" />
                      Volver Atrás
                    </Button>
                  </div>

                  <div>
                    <Button
                      onClick={handleGoHome}
                      className="bg-gradient-to-r from-[var(--color-success)] to-emerald-600 hover:-translate-y-1 hover:scale-110 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-200 flex items-center gap-2"
                    >
                      <Home className="h-4 w-4" />
                      Ir al Inicio
                    </Button>
                  </div>
                </div>

                {/* Información adicional */}
                <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200" >
                  <p className="text-sm text-blue-700 flex items-center justify-center gap-2">
                    <AlertCircle className="h-4 w-4" />
                    Si crees que esto es un error, contacta al soporte técnico.
                  </p>
                </div>

                {/* Enlace de soporte */}
                <div
                  className="mt-6"
                >
                  <a
                    href="mailto:soporte@almacenute.com"
                    className="py-2 px-2 rounded-md text-[var(--color-accent)] hover:text-white hover:bg-[var(--color-secondary)] font-medium transition-colors duration-200 text-sm"
                  >
                    soporte@almacenute.com
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
        <div
          className="absolute -bottom-10 -left-10 w-32 h-32 bg-[var(--color-accent)] opacity-60 rounded-full animate-pulse"
        />
        <div
          className="absolute -top-10 -right-10 w-40 h-40 bg-[var(--color-success)] opacity-60 rounded-full animate-pulse"
        />
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute top-20 right-20 w-10 h-10 bg-[var(--color-primary)] opacity-60 rounded-full animate-pulse"
          />
          <div
            className="absolute bottom-20 left-32 w-20 h-20 bg-[var(--color-secondary)] opacity-60 rounded-full animate-pulse"
          />
          <div
            className="absolute top-10 left-10 w-10 h-10 bg-[var(--color-accent)] opacity-10 rounded-full animate-pulse"
          />
        </div>
      </motion.div>
    </Layout>
  );
}